import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsByVendor",
    title: "Auto Tag Products By Vendor",
    description: "Automatically tag products using the \"Vendor\" field. ",
    example: "If a product has vendor MyVendor, a tag MyVendor will be added to the product.",
    additional: [
        "You can specify prefix, capitalization, and spacing settings for tags",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    dataPermissions: ["products"],
    allowPreview: true,
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsByVendor",
                prefix: null,
                casingTransformation: "KeepOriginal",
                spacesTransformation: "KeepSpaces",
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.casingTransformation == null || rule.settings.casingTransformation === "") {
                        errors["casingTransformation"] = "Casing value is required";
                    }

                    if (rule.settings.spacesTransformation == null || rule.settings.spacesTransformation === "") {
                        errors["spacesTransformation"] = "Spaces value is required";
                    }
                }
            ], null);
    }
};

export default ruleDefinition;